module.exports = __webpack_public_path__ + "static/media/config.f267adb5.png";